import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker, Popup, Tooltip } from 'react-leaflet';
import cx from 'classnames';
import L from 'leaflet';
import { translate } from 'react-i18next';
import $ from 'jquery';

import { getLocationText } from '../../utils/geo';
import { MarkerTooltip } from './MarkerTooltip';

@translate(['journey'], { wait: true })
class RideMarker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.activeTooltip !== this.tooltipComponent && nextProps.activeTooltip !== null) {
      this.setState({
        active: false }, () => {
        $(this.marker.leafletElement._icon).find('.map-point').addClass('inactive');
        $(this.marker.leafletElement._icon).find('.map-point').removeClass('active');
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.active !== this.state.active) {
      return true;
    }
    if (nextProps.event.geoData !== this.props.event.geoData) {
      return true;
    }
    return nextProps.event !== this.props.event;
  }

  componentWillUnmount() {
    if (this.tooltip) {
      $(this.tooltip).off(['mouseenter', ',mouseleave']);
    }
  }

  handleMarkerMouseOver = () => {
    if (!this.state.active) {
      this.setState({ active: true }, () => {
        $(this.marker.leafletElement._icon).find('.map-point').addClass('active');
        $(this.marker.leafletElement._icon).find('.map-point').removeClass('inactive');
      });
    }
  };
  handleMarkerMouseOut = () => {
    if (this.state.active) {
      clearTimeout(this.tooltipTimeout);
      this.tooltipTimeout = setTimeout(() => {
        this.setState({ active: false }, () => {
          $(this.marker.leafletElement._icon).find('.map-point').addClass('inactive');
          $(this.marker.leafletElement._icon).find('.map-point').removeClass('active');
        });
      }, 500);
    }
  };

  handleMouseEnterEvents = (tooltip) => {
    if (this.tooltip) {
      $(this.tooltip).off(['mouseenter', ',mouseleave']);
    }
    $(tooltip).on('mouseenter', () => {
      clearTimeout(this.tooltipTimeout);
    });
    $(tooltip).on('mouseleave', () => {
      this.handleMarkerMouseOut();
    });
    this.tooltip = tooltip;
  };

  render() {
    const { t } = this.props;
    const penalties = this.props.event.penalties;
    const position = [this.props.event.lat / 10000000, this.props.event.lon / 10000000];
    const self = this;

    const iconClassName = cx('map-point', {
      'map-point-speeding': penalties.speeding,
      'map-point-acceleration': penalties.accelerating,
      'map-point-braking': penalties.braking,
      'map-point-maneuvers': penalties.cornering,
    });

    const icon = L.divIcon({
      html: `<div class="${iconClassName}"></div>`,
    });
    return (
      <div>
        <Marker
          ref={(marker) => { this.marker = marker; }}
          icon={icon}
          position={position}
          onMouseOver={this.handleMarkerMouseOver}
          onMouseOut={this.handleMarkerMouseOut}
        >
          {
            this.state.active && <Tooltip
              ref={(tooltipComponent) => { self.tooltipComponent = tooltipComponent; self.props.onTooltipRendered(tooltipComponent); }}
              className="marker-tooltip"
              permanent
              direction="top"
              opacity="0.5"
            >
              <MarkerTooltip
                handleRef={this.handleMouseEnterEvents}
                penalties={penalties}
                eventId={this.props.event.id}
                locationText={getLocationText(this.props.event.geoData)}
                t={t}
                onAppealClick={() => {
                  this.setState({ active: false }, () => {
                    $(this.marker.leafletElement._icon).find('.map-point').addClass('inactive');
                    $(this.marker.leafletElement._icon).find('.map-point').removeClass('active');
                  });
                  this.props.onAppealClick();
                }}
              />
            </Tooltip>
          }
        </Marker>
      </div>
    );
  }
}

RideMarker.propTypes = {
  event: PropTypes.object,
  activeTooltip: PropTypes.object,
  onAppealClick: PropTypes.func.isRequired,
  onTooltipRendered: PropTypes.func.isRequired,
};

RideMarker.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
};

export default RideMarker;



// WEBPACK FOOTER //
// ./src/components/JourneyMap/RideMarker.js